import React from "react";

const category = [
  { id: 1, name: "Legal", displayOn: ["en", "cn", "ru"] },
  { id: 2, name: "Construction", displayOn: ["en", "cn", "ru"] },
  {
    id: 3,
    name: "Estate And Property Management",
    displayOn: ["en", "cn", "ru"],
  },
  { id: 4, name: "Owner benefits", displayOn: ["en", "cn", "ru"] },
  { id: 5, name: "Financing", displayOn: ["en", "cn", "ru"] },
];

const faqs = [
  {
    categoryId: 1,
    question: {
      en: "What types of ownership are available?",
      ru: "Какие формы собственности существуют?",
      cn: "有哪些类型的所有权?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Condominiums are available on a freehold basis for both Thai and
            non-Thai buyers. However, according to current Thai law, non-Thais
            may only purchase up to 49% of the condominium’s saleable area on a
            freehold basis. Otherwise, they may purchase any remaining units on
            a renewable leasehold basis (currently for a maximum period of 30
            years as permitted by law).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Приобретение квартир в кондоминиумах в полную собственность возможно
            как для тайских покупателей, так и для иностранцев. Однако, согласно
            действующему законодательству Таиланда, покупатели, не являющиеся
            тайцами, могут приобрести в собственность только до 49% общего
            количества квартир в комплексе. При этом остальные квартиры можно
            приобрести на условиях долгосроочной аренды с возможностью
            многократного продления аренды (на данный момент максимальный срок
            аренды в соответствии с законодательством составляет на 30 лет).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            对于泰国和非泰国买家来说，公寓都可购买永久产权。然而，根据泰国现行法律，非泰国人最多只能购买49%的公寓可出售面积。否则，他们可通过可续租的租赁产权方式（目前法律允许的最长租期为30年）购买任何剩余的单元。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "What are the costs associated with the lease / freehold registration?",
      ru: "Каковы затраты, связанные с арендой / регистрацией собственности?",
      cn: "与租赁/永久产权登记相关的费用是多少?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Lease registration fees and stamp duty (currently 1.1% of the lease
            premium) is payable to the Land Department upon registration of the
            lease. The cost of lease renewals will be borne by the lessee
            according to the contracts
          </p>
          <p>
            Freehold registration fees (currently 2.0% of the appraisal price)
            is payable to the Land Department upon transfer and registration of
            title. The appraisal price is assessed by Thailand’s Treasury
            Department which is generally below market value. Other applicable
            taxes upon transfer and registration of freehold title are:{" "}
          </p>
          <ul>
            <li>
              <p>
                Corporate Income Withholding Tax (currently 1.0% of the selling
                price or appraisal price, whichever is higher)
              </p>
            </li>
            <li>
              <p>
                Specific Business Tax (currently 3.3% of the selling price or
                appraisal price, whichever is higher)
              </p>
            </li>
          </ul>
          <p>
            The burden between seller and buyer for the above costs will be
            specified in the relevant agreements.
          </p>
          <p>
            <small>
              <em>
                Note: Applicable rates stated are current and may be subject to
                change.
              </em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Сборы за регистрацию аренды и гербовый сбор (в настоящее время 1,1 %
            от арендной платы) уплачиваются в Земельный департамент при
            регистрации аренды. Расходы по продлению аренды несет арендатор в
            соответствии с условиями договоров.
          </p>
          <p>
            Сборы за регистрацию права собственности (в настоящее время 2,0 % от
            оценочной стоимости) уплачиваются в Земельный департамент при
            передаче и регистрации права собственности. Оценочная стоимость
            определяется Министерством финансов Таиланда и обычно является ниже
            рыночной. Другие применимые налоги при передаче и регистрации права
            собственности включают следующие:{" "}
          </p>
          <ul>
            <li>
              <p>
                Налог на доходы юридических лиц (в настоящее время составляет
                1,0 % от продажной стоимости или оценочной стоимости, в
                зависимости от того, какая из них выше)
              </p>
            </li>
            <li>
              <p>
                Специальный налог на прибыль (в настоящее время составляет 3,3 %
                от продажной стоимости или оценочной стоимости, в зависимости от
                того, какая из них выше)
              </p>
            </li>
          </ul>
          <p>
            Обязательства продавца и покупателя по оплате вышеуказанных расходов
            оговаривается в соответствующих договорах.
          </p>
          <p>
            <small>
              <em>
                Примечание: Применимые ставки указаны по состоянию на текущий
                момент и могут быть изменены.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.租赁登记时须向国土部门缴付租赁登记费和印花税（当前为租赁费的1.1%）。租赁续期的费用将根据合同由承租人承担。
          </p>
          <p>
            永久产权转让和登记时，应向国土部门缴付产权登记费（当前为估价的2.0%）。估价由泰国财政部评估，一般会低于市场价值。永久产权转让和登记时适用的其他税包括：
          </p>
          <ul>
            <li>
              <p>企业所得预扣税（当前为售价或估价的1.0%，以较高者为准）</p>
            </li>
            <li>
              <p>特殊营业税（当前为售价或估价价的3.3%，以较高者为准）</p>
            </li>
          </ul>
          <p>卖方和买方对上述费用的承担将在相关协议中规定。</p>
          <p>
            <small>
              <em>注：所列的适用费率为当前情况，可能会有变化。</em>
            </small>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Is a leasehold condominium transferable?",
      ru:
        "Можно ли передать права долгосречной аренды на  квартиры в жилом комплексе другим лицам?",
      cn: "租赁公寓可以转让吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes. Leasehold condominiums may be transferred subject to the terms
            and conditions of the lease agreement. Generally, a small fee is
            payable. In addition, the new owner must agree to be bound by the
            terms and conditions contained in the original lease agreement.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Да. Права долгосрочной аренды на квартиры в кондоминиуме могут быть
            переданы другим лицам в соответствии с условиями договора аренды.
            Как правило, за это взимается небольшая плата. Кроме того, новый
            арендатор должен взять обязательство по соблюдению условий,
            содержащихся в первоначальном договоре аренды.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.可以。租赁公寓可以按照租赁协议的条款和条件转让。通常需要支付少量费用。此外，新业主必须同意受原租约条款约束。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Is leasehold ownership secure?",
      ru: "Защищены ли права арендатора на арендованную недвижимость?",
      cn: "租赁所有权安全吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Leasehold ownership is a common method of ownership for foreign
            buyers. Once the lease is registered at the Land Department, the
            lessee’s rights over the condominium unit will be officially
            recognized.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Владение на правах долгосрочной аренды — распространенный способ
            владения недвижимостью иностранными покупателями. После регистрации
            договора аренды в Земельном департаменте официально признаются права
            арендатора на квартиру в жилом комплексе.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.租赁产权是外国买家的一种常见所有权方式。租约一旦在国土部门登记，承租人的公寓所有权将得到正式承认。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "When will the registration and transfer of the condominiums take place?",
      ru:
        "В какой момент происходит регистрация и передача прав на квартиры в жилом комплексе?",
      cn: "公寓的登记和转让什么时候进行？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Approximately 90 days after full payment has been received and
            construction of all buildings in the Project are completed. We will
            notify the owner of any documents and fees required for
            registration. Owners may opt to accept the hand-over of their
            purchased/leased unit and move in before registration and transfer
            of condominium unit ownership, upon the occupancy permit of the
            building being granted (terms and conditions apply).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Приблизительно через 90 дней после получения полной оплаты и
            завершения строительства всех зданий в рамках Проекта. Мы уведомим
            владельца о том, какие документы и пошлины необходимы для
            регистрации. Владельцы могут начать пользоваться своей квартирой и
            вьехать до регистрации ипередачи права собственности на квартиру в
            кондоминиуме при наличии разрешения на проживание в этом здании
            (применяются условия).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.在收到全部款项并完成项目中所有建筑的建造后大约90天。我们将告知业主所需的所有文件和登记费用。业主可选择在登记和转让公寓所有权之前，当取得建筑使用许可（适用条款和条件）后，接受其购买/租赁公寓的移交并搬入。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Should I appoint a lawyer to review the agreements?",
      ru: "Должен ли я нанять адвоката для проверки соглашений?",
      cn: "我应该请律师来审阅这些协议吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Our agreements have been used for a number of years and have been
            reviewed by major international law firms. We have our own in-house
            legal team which can assist to clarify any questions you may have
            concerning the agreements. However, should you wish to obtain
            specific advice regarding the structuring of your investment, we
            recommend you consult with a professional legal and/or financial
            adviser.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Наши соглашения используются уже много лет и прошли проверку
            крупными международными юридическими фирмами. У нас есть свои
            юристы, которые могут ответить на любые ваши вопросы по соглашениям.
            Однако, если вы хотите получить конкретные рекомендации по
            структурированию инвестиций, мы рекомендуем проконсультироваться с
            профессиональным юридическим и (или) финансовым консультантом.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.我们的协议已经使用多年，并经主流国际律师事务所审核。我们拥有自己的内部法律团队，可以帮助澄清关于协议的任何问题。然而，如果你希望获得关于你的投资结构的具体建议，建议你咨询专业的法律和/或财务顾问。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "What types of visas are available for foreigners to stay in Thailand?",
      ru: "Какие типы виз доступны иностранцам для пребывания в Таиланде?",
      cn: "外国人在泰国可以获得哪些签证？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            There are various forms of visas available to foreigners who wish to
            enter Thailand for study, business, investment, retirement and other
            purposes ranging from 90 days to 1 year multiple entry which
            include.
          </p>
          <ul>
            <li>
              Education visa when enrolled at registered education institution
              within Thailand
            </li>
            <li>Business visa when operating a business</li>
            <li>
              Retirement visa for people aged 50 years or over and meet
              financial requirements
            </li>
            <li>Marriage visa for foreigners married to a Thai</li>
            <li>
              Thailand Elite Visa - a government led program offering
              memberships including 5 year visas
            </li>
          </ul>
          <p>
            Please consult with an immigration specialist or Thai Embassy /
            Consulate for more information.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Существуют различные формы виз, доступные для иностранцев, которые
            хотят приехать в Таиланд для учебы, ведения бизнеса, инвестиций,
            выхода на пенсию и других целей на срок от 90 дней до 1 года с
            многократным въездом. К таким визам относятся следующие:
          </p>
          <ul>
            <li>
              Виза для целей получения образования при поступлении в
              аккредитованное учебное заведение в Таиланде
            </li>
            <li>Деловая виза для ведения предпринимательской деятельности</li>
            <li>
              Пенсионная виза для людей в возрасте 50 лет и старше, которые
              отвечают необходимым финансовым требованиям
            </li>
            <li>
              Брачная виза для иностранцев, состоящих в браке с тайцем или
              тайкой
            </li>
            <li>
              Таиландская элитная виза, выдаваемая по правительственной
              программе и предлагающая членство, включая визы, выдаваемые на
              срок 5 лет
            </li>
          </ul>
          <p>
            Для получения дополнительной информации проконсультируйтесь со
            специалистом по вопросам иммиграции или посольством/консульством
            Таиланда.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.从90天到1年的多次入境，有多种形式的签证可供外国人因学习、商务、投资、退休和其他目的来泰国，其中包括：
          </p>
          <ul>
            <li>在泰国注册教育机构就读时的教育签证</li>
            <li>经营企业时的商务签证</li>
            <li>退休签证，适用于年龄在50岁或50岁以上并满足财务要求的人</li>
            <li>婚姻签证，适用于与泰国人结婚的外国人</li>
            <li>泰国精英签证，一个政府主导项目，提供包含5年签证的会员资格</li>
          </ul>
          <p>请咨询移民专家或泰国大使馆/领事馆了解更多信息。</p>
        </div>
      ),
    },
  },
  // ====================================================================== //
  {
    categoryId: 2,
    question: {
      en: "Types and number of units for sale?",
      ru: "Каковы типы и количество квартир на продажу?",
      cn: "待售单元的种类和数量如何？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The development includes four (4) low-rise condominium buildings
            comprising a total of approximately 185 units. One, two and three
            bedroom configurations are available ranging in size from 59 – 131
            square metres.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Проект включает четыре (4) малоэтажных здания-кондоминиума
            приблизительно на 185 квартир. Доступны варианты с одной, двумя и
            тремя спальнями площадью от 59 до 131 квадратных метров.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            该项目包括四栋低层公寓楼，共包含约185个单元。一卧室、两卧室和三卧室公寓的面积从
            59-131平方米不等。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "How long does construction take?",
      ru: "Сколько времени занимает строительство?",
      cn: "建筑施工需要多长时间？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Construction can only commence once the relevant government
            environmental and building approvals are obtained and is estimated
            to take approximately 20-24 months for each building to complete
            from the commencement date.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Строительство может начаться только после получения соответствующих
            государственных разрешений природоохранных органов и разрешений на
            выполнение строительных работ. Предварительно, на строительство
            каждого здания с даты начала строительства потребуется примерно от
            20 до 24 месяцев.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.在获得相关的政府环境和建筑批准后才能开始施工。从开工日期开始，每栋建筑估计需要大约20-24个月的时间完成。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Is a warranty period offered?",
      ru: "Имеется ли гарантийный срок?",
      cn: "提供保修期吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes. A five (5) year building structure warranty is offered from the
            date of completion of construction. Warranties on materials and
            furnishings will be subject to a one (1) year warranty.
          </p>
          <p>
            <small>
              <em>*Subject to exclusion under contract and law.</em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Да. Гарантия на строительную конструкцию составляет 5 (пять) лет с
            даты завершения строительства. Гарантия на материалы и мебель
            составляет 1 (один) год.
          </p>
          <p>
            <small>
              <em>
                *За исключением случаев, предусмотренных договором и
                законодательством.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            是的。自竣工之日起，提供为期五年的建筑结构保修。材料和家具的保修期为一年。
          </p>
          <p>
            <small>
              <em>*受合同和法律规定的除外责任约束。</em>
            </small>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "What is included in the property?",
      ru: "Что включено в приобретаемую недвижимость?",
      cn: "房产内包含什么？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Basic fit-out option includes flooring, walls, sanitary ware,
            kitchen bench, sink, air-conditioning. Fitted option includes fixed
            furnishings (wardrobes, kitchen cabinets and built-in kitchen
            appliances, etc). Furnished option includes loose furniture and
            amenities (beds, sofa, dining table and chairs, curtains, fridge,
            microwave, etc).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            В базовую комплектацию входят чистовая отделка полов и стен,
            сантехника, кухонная столешница, раковина, кондиционер. Далее идет
            комплектация, включающая встроенную мебель и технику (гардеробы,
            кухонные гарнитуры, встроенное кухонное оборудование и т. п.).
            Комплектация под ключ включает свободно стоящую мебель и предметы
            домашнего быта (кровати, диван, обеденный стол и стулья, шторы,
            холодильник, микроволновая печь и т. п.).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            简装选项包括地板、墙壁、卫生洁具、厨房工作台、水槽、空调。精装选项包括固定家具（衣柜、厨房橱柜和嵌入式厨房电器等）。全装全配选项包括可移动家具和设施（床、沙发、餐桌和椅子、窗帘、冰箱、微波炉等）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Is customization of the units allowed?",
      ru: "Разрешена ли перепланировка квартир?",
      cn: "允许定制单元吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            There are two (2) interior design options available and another
            option to enclose the balcony. The building must be built in
            accordance with building code and permits as issued by the relevant
            authorities so no changes to the external areas or structural items
            are permitted.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Доступны 2 (два) варианта внутренней планировки и еще один вариант,
            включающий балкон. Здание должно строиться в соответствии со
            строительными нормами и разрешениями, выданными соответствующими
            органами, поэтому никакие изменения внешних участков или элементов
            конструкции не допускаются.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            有两种室内设计可供选择，另可封闭阳台。建筑必须按照建筑规范和相关部门颁发的许可证建造，因此外部区域或结构项目不得更改。
          </p>
        </div>
      ),
    },
  },
  // ====================================================================== //
  {
    categoryId: 3,
    question: {
      en:
        "What infrastructure and common facilities are provided and who will manage these?",
      ru:
        "Что входит в инфраструктуру и общие объекты и кто будет ими управлять?",
      cn: "提供哪些基础设施和公共设施，由谁来管理？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The infrastructure and common facilities includes roads and
            drainage, lighting, landscape areas, swimming pools, deck areas and
            water and electricity supplies. Services shall include 24 hours
            on-site security, garbage collection, cleaning and maintenance of
            infrastructure and common facilities or any other services as
            required for the common use or benefit of owners. In addition,
            owners will be entitled to access certain amenities including the
            shuttle bus service. The condominium manager shall be Laguna (or its
            designated manager).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Инфраструктура и общие объекты включают дороги и канализацию,
            освещение, ландшафтные зоны, бассейны, террасы, а также водо- и
            электроснабжение. Услуги включают круглосуточную охрану в месте
            объекта, вывоз мусора, уборку и обслуживание инфраструктуры и общих
            объектов, а также все другие услуги, необходимые для общего
            пользования или выгод владельцев. Также владельцы имеют право на
            доступ к определенным удобствам, включая услуги внутреннего
            транспорта курорта. Управляющим кондоминиумом является Laguna (или
            назначенный ею управляющий).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            基础设施和公用设施包括道路和排水、照明、景观区、游泳池、甲板区、水电供应等。服务包括24小时现场保安、垃圾收集、基础设施和公共设施的清洁和维护或为业主的共同使用或利益所需的任何其他服务。此外，业主将有权使用指定设施，包括班车服务。公寓管理人为乐古浪（或其指定的管理人）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en:
        "What are the estimated fees payable for the infrastructure, common facilities and services provided?",
      ru:
        "Каков ориентировочный размер платы за пользование инфраструктурой, общими объектами и услугами?",
      cn: "针对提供的基础设施、公共设施和服务，需支付的估计费用是多少？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The fees for the cost of maintenance for the infrastructure, common
            facilities, services provided (“common area fee”) and maintenance
            fees towards other services and facilities supplied to the
            condominium “non-common area fees’ in aggregate shall be Baht 50 per
            square metre per month for the initial year and may be subject to
            change based upon the actual expenses incurred from time to time.
            The annual fees are determined by the total expenses incurred and
            proportionately divided amongst the sellable area of the units in
            the condominium.
          </p>
          <p>
            In addition, a fund shall be established for the cost of major
            repairs, replacement and/or improvement for the infrastructure and
            common facilities (“special fund”). Contributions will be made on a
            regular basis so that the fund is built up over time. The rate shall
            be Baht 100 per square metre per year for the initial year and may
            be subject to change. If the fund balance is not sufficient for the
            cost of major repairs, owners may be required to pay an additional
            amount as requested by the manager from time to time.
          </p>
          <p>
            The cost of water and electricity supplied to individual
            condominiums shall be based upon metered consumption.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Плата за содержание инфраструктуры и мест общего пользования, а
            также предоставление услуг (далее — «плата за территорию общего
            пользования») и плата за другие услуги и удобства, предоставляемые
            кондоминиуму (далее «плата за территорию, не входящую в общее
            пользование») в совокупности составляет 50 батов за один квадратный
            метр в месяц в течение первого года. Ее размер может периодически
            пересматриваться в зависимости от фактических расходов. Ежегодный
            размер платы определяется общей суммой понесенных расходов и
            пропорционально распределяется между продаваемой площадью квартир в
            кондоминиуме.
          </p>
          <p>
            Кроме того, создается фонд для покрытия затрат на капитальный
            ремонт, замену и (или) улучшение инфраструктуры и общих объектов
            (далее — «специальный фонд»). Взносы осуществляются на регулярной
            основе с целью постепенного накопления средств фондом. Размер платы
            составляет 100 бат за один квадратный метр в год в течение первого
            года и может пересматриваться. Если остатка средств фонда
            недостаточно для покрытия затрат на капитальный ремонт, управляющий
            периодически может требовать от собственников внесения
            дополнительных сумм.
          </p>
          <p>
            Стоимость воды и электричества, потребляемые отдельными квартирами
            взимается в соответствии с показаниями счетчиков.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            针对提供的基础设施、公用设施、服务的维护费用（“公共区域费”）以及针对提供给公寓的其他服务和设施的维护费用（“非公共区域费”），初始年合计为每月每平方米50泰铢，可能会根据实际支出变动。每年费用由所发生的总支出决定，并按比例在公寓单元的可售面积中分摊。
          </p>
          <p>
            此外，还为基础设施和公共设施的大修、更换和/或改进费用设立基金（“特别基金”）。将定期缴款，以便基金逐步建立。初始年的费率为每年每平方米100泰铢，可能会有变动。如基金余额不足以支付大修费用，业主可能须按管理人不时的要求支付额外款项。
          </p>
          <p>单个公寓的水电费按用量计算。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "What property management services are provided?",
      ru: "Какие услуги по управлению объектами недвижимости предоставляются?",
      cn: "提供哪些物业管理服务？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Laguna Property Management and/or Laguna Beachside Phuket
            hospitality team will provide a full range of property services to
            individual owners including, pest control, routine and preventative
            maintenance, general repairs, housekeeping and other reasonable
            requests. Rates vary according to the frequency and scope of
            service. In addition, Laguna Rentals and/or Laguna Beachside Phuket
            hospitality team provides owners with the ability to generate a
            rental income from their property with short-term* and long-term
            rentals (see below).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Обслуживающий персонал Laguna Property Management и (или) Laguna
            Beachside Phuket предоставляет владельцам полный набор услуг по
            управлению объектами недвижимости, включая борьбу с вредителями,
            текущее и профилактическое обслуживание, общий ремонт, уборку и
            удовлетворение других обоснованных запросов. Размер платы
            варьируется в зависимости от частоты предоставления услуг и их
            объема. Также обслуживающий персонал Laguna Rentals и (или) Laguna
            Beachside Phuket предоставляет владельцам возможность получать доход
            от аренды их недвижимости посредством краткосрочной* и долгосрочной
            аренды (см. информацию ниже).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            乐古浪物业管理和/或乐古浪悦海苑接待团队将为单个业主提供全方位的物业服务，包括虫害防治、例行和预防性维护、一般维修、家政和其他合理要求的服务。收费根据服务的频率和范围而变化。此外，乐古浪租赁和/或乐古浪悦海苑接待团队可使业主从其短期*和长期房产租赁中获取收入（见下文）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "Can I rent my unit out on my own?",
      ru: "Могу ли я сдать свою квартиру самостоятельно?",
      cn: "我可以自己把房子租出去吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes, owners may rent out their property on a long-term basis (6
            months or more) directly or through external agents.
          </p>
          <p>
            For short-term* rentals of 1 to 6 months, these must be conducted
            exclusively through Laguna Rentals who provides owners with the
            ability to generate a rental income from their property when not in
            residence with short-term and long-term rentals.
          </p>
          <p>
            Any short-term* rentals of less than 30 days must be conducted
            exclusively through Laguna Beachside Phuket hospitality team (who
            will hold a hotel license) and will require the fully furnished
            option.
          </p>
          <p>
            <small>
              <em>* Terms and conditions apply</em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Да, собственники могут сдавать свою недвижимость в аренду на
            долгосрочной основе (на 6 и более месяцев) напрямую или через
            посредников.
          </p>
          <p>
            При краткосрочной* аренде, срок которой составляет от 1 до 6
            месяцев, аренда должна осуществляться исключительно через компанию
            Laguna Rentals, которая предоставляет владельцам возможность
            получать доход от их недвижимости, когда они не проживают в ней,
            сдавая ее в аренду на короткий и длительный срок.
          </p>
          <p>
            Сдача недвижимости на короткий* срок, составляющий менее 30 дней,
            должна осуществляться исключительно через обслуживающий персонал
            Laguna Beachside Phuket (который будет обладать лицензией на
            осуществление гостиничной деятельности), при этом соответствующий
            объект недвижимости должен быть укомплектован под ключ.
          </p>
          <p>
            <small>
              <em>* Действуют правила и условия</em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>可以，业主可以直接或通过外部中介长期（6个月或以上）出租其房产。</p>
          <p>
            1至6个月的短期*租赁必须完全通过乐古浪租赁进行，该部门可使业主在不居住时通过短期和长期租赁获取租金收入。
          </p>
          <p>
            任何少于30天的短期*租赁必须通过乐古浪悦海苑服务团队（该团队将持有酒店执照）独家办理，并需选择全装全配选项。
          </p>
          <p>
            <small>
              <em>* 适用条款和条件</em>
            </small>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en:
        "What are the taxes levied on rental income that an owner will be subject to?",
      ru: "Какие налоги взимаются с дохода от аренды, получаемого владельцем?",
      cn: "业主的租金收入需要缴纳什么税？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Owners may be required to file an income tax return in Thailand
            based upon rental income earned and pay the applicable tax. Rental
            distributions made to owners may be subject to withholding tax under
            the Thai Revenue Code with rates ranging from 5 – 15%, subject to
            owners tax structure status.
          </p>
          <p>
            <small>
              <em>
                Note: applicable tax rates are current at the date of issue of
                this FAQ and may be subject to changes. The unit owner shall be
                responsible for any income and any other taxes, duties and fees
                of whatever nature which may be levied by relevant authorities
                on the unit in connection with the rental.
              </em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            От владельцев может потребоваться подача налоговой декларации в
            Таиланде с указанием полученного дохода от аренды и уплатой
            соответствующего налога. В соответствии с налоговым кодексом
            Таиланда выплата арендной платы владельцам может облагаться налогом,
            по ставке от 5 до 15%, в зависимости от налоговой структуры
            владельца.
          </p>
          <p>
            <small>
              <em>
                Примечание: применимые ставки налога действительны на дату
                публикации настоящей информации с ответами на часто задаваемые
                вопросы и могут быть изменены. Владелец квартиры несет
                ответственность за уплату всех налогов на доходы и других
                налогов, пошлин и сборов любого вида, которыми могут облагать
                квартиру соответствующие органы власти в связи с ее сдачей в
                аренду.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            业主可能需要在泰国根据租金收入申报所得税并支付适用的税收。根据泰国税收法典，向业主分配的租金可能要缴纳预扣税，税率为5-15%，视业主税收结构状况而定。
          </p>
          <p>
            <small>
              <em>
                注：适用税率为本常见问题解答发出之日的现行税率，可能会变动。有关部门可能对该单元征收的与租金有关的任何收入税、其他税收和任何性质的费用，由业主负责。
              </em>
            </small>
          </p>
        </div>
      ),
    },
  },
  // ====================================================================== //
  {
    categoryId: 4,
    question: {
      en: "What privileges will I receive as an owner?",
      ru: "Какие привилегии я получу как владелец?",
      cn: "作为业主，我将得到什么特权？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Owners will receive membership to the Banyan Group ‘s signature
            property owners program, the Sanctuary Club*, which entitles then to
            discounts and privileges at Banyan Tree , Angsana, Cassia, Dhawa and
            Laguna resorts, spas and galleries worldwide including:
          </p>
          <ul>
            <li>
              <p>
                30% discount on best available rates for hotel accommodation
              </p>
            </li>
            <li>
              <p>30% discount on golf green fees</p>
            </li>
            <li>
              <p>25% discount on food and beverage</p>
            </li>
            <li>
              <p>20% discount on a-la-carte spa menu</p>
            </li>
            <li>
              <p>15% discount on gallery merchandise</p>
            </li>
            <li>
              <p>15% discount on in-house tours</p>
            </li>
            <li>
              <p>15% discount on laundry</p>
            </li>
            <li>
              <p>10% discount airport transfers</p>
            </li>
            <li>
              <p>Priority wait-list on reservations</p>
            </li>
            <li>
              <p>Early check-in / late check-out</p>
            </li>
            <li>
              <p>
                Invitations to pre-openings of new hotels and Banyan Tree events
              </p>
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Владельцы апартаментов становятся участниками Sanctuary Club* –
            эксклюзивного клуба от Banyan Group для собственников недвижимости,
            что дает им право на скидки и привилегии на всех курортах, в спа и
            торговых галереях в Banyan Tree, Angsana, Cassia, Dhawa and Laguna
            по всему миру, включая следующее:
          </p>
          <ul>
            <li>
              <p>
                Скидка в размере 30% на лучшие доступные цены на проживание в
                отелях
              </p>
            </li>
            <li>
              <p>
                Скидка в размере 30% на плату за пользование полем для гольфа
                («грин-фи»)
              </p>
            </li>
            <li>
              <p>Скидка в размере 25% на еду и напитки</p>
            </li>
            <li>
              <p>Скидка в размере 20% на меню a-la-carte в спа-отелях</p>
            </li>
            <li>
              <p>Скидка в размере 15% на товары в бутиках</p>
            </li>
            <li>
              <p>Скидка в размере 15% на туры, предлагаемые отелями</p>
            </li>
            <li>
              <p>Скидка в размере 15% на услуги прачечной</p>
            </li>
            <li>
              <p>Скидка в размере 10% на трансферы из аэропорта / в аэропорт</p>
            </li>
            <li>
              <p>Приоритет в листе ожидания при бронировании</p>
            </li>
            <li>
              <p>Ранний заезд / поздний выезд</p>
            </li>
            <li>
              <p>
                Приглашения на предпродажные открытия новых отелей и мероприятия
                Banyan Tree
              </p>
            </li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>
            业主将获得悦榕集团的标志性业主计划“榕源会”*会籍，成为该俱乐部会员，可在全球范围的悦榕庄、悦椿、悦梿、悦苑和乐古浪度假村、Spa和艺品阁享受折扣与特权，包括：
          </p>
          <ul>
            <li>
              <p>酒店住宿最优房价7折</p>
            </li>
            <li>
              <p>高尔夫果岭费7折</p>
            </li>
            <li>
              <p>餐饮7.5折</p>
            </li>
            <li>
              <p>水疗中心8折</p>
            </li>
            <li>
              <p>零售艺品阁商品8.5折</p>
            </li>
            <li>
              <p>酒店旅游服务8.5折</p>
            </li>
            <li>
              <p>洗衣服务8.5折</p>
            </li>
            <li>
              <p>机场接送9折</p>
            </li>
            <li>
              <p>预订优先等待名单</p>
            </li>
            <li>
              <p>提早入住/延迟退房</p>
            </li>
            <li>
              <p>新酒店预开业和悦榕活动邀请</p>
            </li>
          </ul>
        </div>
      ),
    },
  },
  // ====================================================================== //
  {
    categoryId: 5,
    question: {
      en: "What are the terms of payment?",
      ru: "Какие предусмотрены условия оплаты?",
      cn: "付款方式是什么?",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>There are 2 options available:</p>
          <p>
            <strong>
              Option 1: 100% Payment upon purchase / during construction
            </strong>
            <br />
            100% payment upon purchase for already completed properties.
            Progressive payments for properties under construction are as per
            the table below.
          </p>
          <table>
            <thead>
              <tr>
                <th>Construction Payment Term</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>th</sup> Payment upon completion of construction
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Total</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>Notes:</em>
          </small>
          <ol className="notes">
            <li>
              <small>
                <em>1. Concrete structure substantially completed.</em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  2. Roof, brickwork and rendering substantially completed.
                </em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  3. Electrical conduits, pipework and plastering substantially
                  completed.
                </em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  4. Interest will be applied to the post-construction deferred
                  balance as outlined under Financing Option.
                </em>
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Option 2: 50% payment upon purchase / during construction with 50%
              deferred payment over 1, 3 or 5 years
            </strong>
            <br />
            50% payment upon purchase for already completed properties.
            Progressive payments for properties under construction (50% during
            construction / 50% post construction) as per the table below
          </p>

          <table>
            <thead>
              <tr>
                <th>Deferred Payment Plan</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Post construction payments
                  <sup>6</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Financing Options</th>
                <th className="th-col2">
                  Interest Rate
                  <br />
                  (per annum)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 Year (4 quarterly installments)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 Year (12 quarterly installments)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 Year (20 quarterly installments)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>1. Concrete structure substantially completed.</small>
            </li>
            <li>
              <small>
                2. Roof, brickwork and rendering substantially completed.
              </small>
            </li>
            <li>
              <small>
                3. Electrical conduits, pipework and plastering substantially
                completed.
              </small>
            </li>
            <li>
              <small>
                4. Interest will be applied to the post-construction deferred
                balance as outlined under Financing Option.
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Price</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Reservation Deposit</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Construction Completion <br />
                    Payment 50% (Minus Deposit)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Remaining Post Finance 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Quarterly Installment</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 Year (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 Year (5%)</strong>
                </td>
                <td>
                  <strong>5 Year (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>5,000,000</td>
                <td>100,000</td>
                <td>2,400,000</td>
                <td>2,500,000</td>
                <td>636,763</td>
                <td>225,646</td>
                <td>149,228</td>
              </tr>
              <tr>
                <td>7,000,000</td>
                <td>100,000</td>
                <td>3,400,000</td>
                <td>3,500,000</td>
                <td>891,468</td>
                <td>315,904</td>
                <td>208,919</td>
              </tr>
              <tr>
                <td>9,000,000</td>
                <td>100,000</td>
                <td>4,400,000</td>
                <td>4,500,000</td>
                <td>1,146,173</td>
                <td>406,162</td>
                <td>268,611</td>
              </tr>
              <tr>
                <td>11,000,000</td>
                <td>100,000</td>
                <td>5,400,000</td>
                <td>5,500,000</td>
                <td>1,400,878</td>
                <td>496,421</td>
                <td>328,302</td>
              </tr>
              <tr>
                <td>13,000,000</td>
                <td>100,000</td>
                <td>6,400,000</td>
                <td>6,500,000</td>
                <td>1,655,583</td>
                <td>586,679</td>
                <td>387,993</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>17,000,000</td>
                <td>100,000</td>
                <td>8,400,000</td>
                <td>8,500,000</td>
                <td>2,164,993</td>
                <td>767,196</td>
                <td>507,375</td>
              </tr>
              <tr>
                <td>19,000,000</td>
                <td>100,000</td>
                <td>9,400,000</td>
                <td>9,500,000</td>
                <td>2,419,698</td>
                <td>857,454</td>
                <td>567,067</td>
              </tr>
              <tr>
                <td>21,000,000</td>
                <td>100,000</td>
                <td>10,400,000</td>
                <td>10,500,000</td>
                <td>2,674,403</td>
                <td>947,712</td>
                <td>626,758</td>
              </tr>
              <tr>
                <td>23,000,000</td>
                <td>100,000</td>
                <td>11,400,000</td>
                <td>11,500,000</td>
                <td>2,929,108</td>
                <td>1,037,971</td>
                <td>686,449</td>
              </tr>
              <tr>
                <td>25,000,000</td>
                <td>100,000</td>
                <td>12,400,000</td>
                <td>12,500,000</td>
                <td>3,183,813</td>
                <td>1,128,229</td>
                <td>746,140</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>1. All amounts are stated in Thai Baht (THB).</small>
            </li>
            <li>
              <small>
                2. The above table sets out the estimated payments required
                under the respective payment plans for selling prices between
                THB 5,000,000 – 25,000,000.
              </small>
            </li>
            <li>
              <small>
                3. The estimated payments are indicative only and the developer
                / seller does not accept any responsibility or liability
                whatsoever for any inaccuracies or omissions.
              </small>
            </li>
            <li>
              <small>
                4. Payment terms are subject to change without notice.
              </small>
            </li>
          </ol>
        </div>
      ),
      ru: (
        <div>
          <p>
            Для всех новых объектов недвижимости мы предлагаем 2 варианта
            оплаты:
          </p>
          <p>
            <strong>
              Вариант 1. 100 % оплата при покупке / во время строительства
            </strong>
            <br />
            100% оплата при покупке готовых объектов. Прогрессивные платежи для
            строящихся объектов представлены в таблице ниже.
          </p>
          <table>
            <thead>
              <tr>
                <th>Срок платежа на момент строительства</th>
                <th className="th-col2">% от цены продажи</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1-й платеж при заключении договора</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2-й платеж при 25-процентной готовности объекта<sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3-й платеж при 50-процентной готовности объекта
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4-й платеж при 75-процентной готовности объекта
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>5-й платеж по окончании строительства</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Всего</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>1. Коробка здания в основном возведена.</small>
            </li>
            <li>
              <small>
                2. Возведение кровли, кирпичная кладка и штукатурка наружной
                поверхности стен в основном завершены.
              </small>
            </li>
            <li>
              <small>
                3. Электропроводка, разводка труб и внутреннее оштукатуривание в
                основном завершены.
              </small>
            </li>
            <li>
              <small>
                4. На отложенный остаток оплаты после завершения строительства
                начисляются проценты в соответствии с разделом «Варианты
                финансирования».
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Вариант 2. Первые 50 % при покупке / по этапам строительства и
              вторые 50 % в рассрочку в течение 1, 3 или 5 лет
            </strong>
            <br />
            50 % оплаты при покупке завершенных объектов. Прогрессивные платежи
            для строящихся объектов (50 % по этапам строительства / 50 % после
            завершения строительства) представлены в таблице ниже.
          </p>

          <table>
            <thead>
              <tr>
                <th>График отложенных платежей</th>
                <th className="th-col2">% от цены продажи</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1-й платеж при заключении договора</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2-й платеж при 25-процентной готовности объекта
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3-й платеж при 50-процентной готовности объекта
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4-й платеж при 75-процентной готовности объекта
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Платежи по окончании строительства
                  <sup>6</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Варианты финансирования</th>
                <th className="th-col2">
                  Процентная
                  <br />
                  ставка (годовых)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 год (4 ежеквартальных платежа)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 года (12 ежеквартальных платежей)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 лет (20 ежеквартальных платежей)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>1. Коробка здания в основном возведена.</small>
            </li>
            <li>
              <small>
                2. Возведение кровли, кирпичная кладка и штукатурка наружной
                поверхности стен в основном завершены.
              </small>
            </li>
            <li>
              <small>
                3. Электропроводка, разводка труб и внутреннее оштукатуривание в
                основном завершены.
              </small>
            </li>
            <li>
              <small>
                4. На отложенный остаток оплаты после завершения строительства
                начисляются проценты в соответствии с разделом «Варианты
                финансирования».
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Цена</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Депозит</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Оплата 50 % по
                    <br />
                    завершению
                    <br />
                    строительст
                    <br />
                    ва (минус депозит)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Оплата
                    <br />
                    оставшихс
                    <br />я 50 %
                  </strong>
                </td>
                <td colSpan="3">
                  <strong>Ежеквартальные взносы</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 год (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 года (5%)</strong>
                </td>
                <td>
                  <strong>5 год (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>5,000,000</td>
                <td>100,000</td>
                <td>2,400,000</td>
                <td>2,500,000</td>
                <td>636,763</td>
                <td>225,646</td>
                <td>149,228</td>
              </tr>
              <tr>
                <td>7,000,000</td>
                <td>100,000</td>
                <td>3,400,000</td>
                <td>3,500,000</td>
                <td>891,468</td>
                <td>315,904</td>
                <td>208,919</td>
              </tr>
              <tr>
                <td>9,000,000</td>
                <td>100,000</td>
                <td>4,400,000</td>
                <td>4,500,000</td>
                <td>1,146,173</td>
                <td>406,162</td>
                <td>268,611</td>
              </tr>
              <tr>
                <td>11,000,000</td>
                <td>100,000</td>
                <td>5,400,000</td>
                <td>5,500,000</td>
                <td>1,400,878</td>
                <td>496,421</td>
                <td>328,302</td>
              </tr>
              <tr>
                <td>13,000,000</td>
                <td>100,000</td>
                <td>6,400,000</td>
                <td>6,500,000</td>
                <td>1,655,583</td>
                <td>586,679</td>
                <td>387,993</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>17,000,000</td>
                <td>100,000</td>
                <td>8,400,000</td>
                <td>8,500,000</td>
                <td>2,164,993</td>
                <td>767,196</td>
                <td>507,375</td>
              </tr>
              <tr>
                <td>19,000,000</td>
                <td>100,000</td>
                <td>9,400,000</td>
                <td>9,500,000</td>
                <td>2,419,698</td>
                <td>857,454</td>
                <td>567,067</td>
              </tr>
              <tr>
                <td>21,000,000</td>
                <td>100,000</td>
                <td>10,400,000</td>
                <td>10,500,000</td>
                <td>2,674,403</td>
                <td>947,712</td>
                <td>626,758</td>
              </tr>
              <tr>
                <td>23,000,000</td>
                <td>100,000</td>
                <td>11,400,000</td>
                <td>11,500,000</td>
                <td>2,929,108</td>
                <td>1,037,971</td>
                <td>686,449</td>
              </tr>
              <tr>
                <td>25,000,000</td>
                <td>100,000</td>
                <td>12,400,000</td>
                <td>12,500,000</td>
                <td>3,183,813</td>
                <td>1,128,229</td>
                <td>746,140</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>1. Все суммы указаны в тайских батах.</small>
            </li>
            <li>
              <small>
                2. В приведенной выше таблице указаны расчетные суммы платежей,
                предусмотренных соответствующими графиками для объектов
                недвижимости с продажной стоимостью от 5 000 000 до 25 000 000
                THB.
              </small>
            </li>
            <li>
              <small>
                3. Платежи являются лишь ориентировочными и застройщик /
                продавец не несет ответственности за любые неточности или
                ошибки.
              </small>
            </li>
            <li>
              <small>
                4. Условия оплаты могут быть изменены без предварительного
                уведомления.
              </small>
            </li>
          </ol>
        </div>
      ),
      cn: (
        <div>
          <p>两种付款计划：</p>
          <p>
            <strong>选择 1:购买/施工期间全额付款</strong>
            <br />
            购买已竣工物业时全额付款。
            对于在建物业，按下表根据施工进度分期付款。
          </p>
          <table>
            <thead>
              <tr>
                <th>施工进度付款计划</th>
                <th className="th-col2">付款比例</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>签署合同时进行首付</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  工程完成 25%时进行第 2 次付款
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  工程完成 50%时进行第 3 次付款
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  工程完成 75%时进行第 4 次付款
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>竣工时进行第 5 次付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>合计</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>备注:</small>
          <ol className="notes">
            <li>
              <small>1. 混凝土结构基本完成。</small>
            </li>
            <li>
              <small>2. 屋顶、砖砌和粉刷基本完成。</small>
            </li>
            <li>
              <small>3. 电力管、管道工程和抹灰基本完成。</small>
            </li>
            <li>
              <small>4. 竣工后延期付款余额需支付财务选择中所列的利息。</small>
            </li>
          </ol>
          <p>
            <strong>
              选择 2:购买时/施工期间付款 50%，剩余的 50%延期款项在 1 年、3 年或
              5 年内支付
            </strong>
            <br />
            购买已竣工物业支付
            50%的款项。对于在建物业，按下表根据施工进度分期付款(施工期间付 款
            50%/竣工后付款 50%)。
          </p>

          <table>
            <thead>
              <tr>
                <th>延期付款计划</th>
                <th className="th-col2">付款比例</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>签署合同时进行首付</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  工程完成 25%时第 2 次付款
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  工程完成 50%时第 3 次付款
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  工程完成 75%时第 4 次付款
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  竣工后付款
                  <sup>6</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>分期付款选择</th>
                <th className="th-col2">利率(每年)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 年 (4 个季度分期付款)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 年 (12 个季度分期付款)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 年 (20 个季度分期付款)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>备注:</small>
          <ol className="notes">
            <li>
              <small>1. 混凝土结构基本完成。</small>
            </li>
            <li>
              <small>2. 屋顶、砖砌和粉刷基本完成。</small>
            </li>
            <li>
              <small>3. 电力管、管道工程和抹灰基本完成。</small>
            </li>
            <li>
              <small>4. 竣工后延期付款余额需支付财务选择中所列的利息。</small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>价格</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>预定金</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>施工期间付款 50% (减去定金)</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>竣工后付款 50%</strong>
                </td>
                <td colSpan="3">
                  <strong>按季度分期付款</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 年 (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 年 (5%)</strong>
                </td>
                <td>
                  <strong>5 年 (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>5,000,000</td>
                <td>100,000</td>
                <td>2,400,000</td>
                <td>2,500,000</td>
                <td>636,763</td>
                <td>225,646</td>
                <td>149,228</td>
              </tr>
              <tr>
                <td>7,000,000</td>
                <td>100,000</td>
                <td>3,400,000</td>
                <td>3,500,000</td>
                <td>891,468</td>
                <td>315,904</td>
                <td>208,919</td>
              </tr>
              <tr>
                <td>9,000,000</td>
                <td>100,000</td>
                <td>4,400,000</td>
                <td>4,500,000</td>
                <td>1,146,173</td>
                <td>406,162</td>
                <td>268,611</td>
              </tr>
              <tr>
                <td>11,000,000</td>
                <td>100,000</td>
                <td>5,400,000</td>
                <td>5,500,000</td>
                <td>1,400,878</td>
                <td>496,421</td>
                <td>328,302</td>
              </tr>
              <tr>
                <td>13,000,000</td>
                <td>100,000</td>
                <td>6,400,000</td>
                <td>6,500,000</td>
                <td>1,655,583</td>
                <td>586,679</td>
                <td>387,993</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>17,000,000</td>
                <td>100,000</td>
                <td>8,400,000</td>
                <td>8,500,000</td>
                <td>2,164,993</td>
                <td>767,196</td>
                <td>507,375</td>
              </tr>
              <tr>
                <td>19,000,000</td>
                <td>100,000</td>
                <td>9,400,000</td>
                <td>9,500,000</td>
                <td>2,419,698</td>
                <td>857,454</td>
                <td>567,067</td>
              </tr>
              <tr>
                <td>21,000,000</td>
                <td>100,000</td>
                <td>10,400,000</td>
                <td>10,500,000</td>
                <td>2,674,403</td>
                <td>947,712</td>
                <td>626,758</td>
              </tr>
              <tr>
                <td>23,000,000</td>
                <td>100,000</td>
                <td>11,400,000</td>
                <td>11,500,000</td>
                <td>2,929,108</td>
                <td>1,037,971</td>
                <td>686,449</td>
              </tr>
              <tr>
                <td>25,000,000</td>
                <td>100,000</td>
                <td>12,400,000</td>
                <td>12,500,000</td>
                <td>3,183,813</td>
                <td>1,128,229</td>
                <td>746,140</td>
              </tr>
            </tbody>
          </table>
          <small>备注:</small>
          <ol className="notes">
            <li>
              <small>1. 货币单位为泰铢。</small>
            </li>
            <li>
              <small>
                2. 上表列出了销售价格为5,000,000 –
                25,000,000泰铢时，相应付款计划所需支付的预计金额。
              </small>
            </li>
            <li>
              <small>
                3. 预计付款金额仅供参考。如有错漏，开发商/销售方概不负责。
              </small>
            </li>
            <li>
              <small>4. 付款方式如有更改，恕不另行通知。</small>
            </li>
          </ol>
        </div>
      ),
    },
  },
];

export { category, faqs };



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/faq.js